import styled from 'styled-components';

const ImgLogoWhite = styled.img`
  max-width: 8rem;
`;

export default ImgLogoWhite;
